var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 108,
    fill: "none",
    viewBox: "0 0 109 108",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#510a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#511b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.553.058H26.55v3.003h3.003zM35.385.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3.058h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217.058h-3.004v3.003h3.004zM47.048.058h-3.003v3.003h3.003zM55.795.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543.058h-3.004v3.003h3.004zM70.374.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29.058h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206.058h-3.003v3.003h3.003zM84.953.058H81.95v3.003h3.003zM38.3 2.974h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 2.974h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 2.974H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 2.974h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 2.974H46.96v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 2.974h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 2.974h-3.003v3.003h3.003zM73.29 2.974h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 2.974h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 2.974h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 2.974h-3.004v3.003h3.003zM26.638 5.89h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 5.89H26.55v3.003h3.003zM35.385 5.89h-3.003v3.003h3.003zM49.964 5.89H46.96v3.003h3.003zM61.627 5.89h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 5.89h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 5.89h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 5.89h-3.003v3.003h3.003zM79.122 5.89h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 5.89h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 5.89H81.95v3.003h3.003zM26.638 8.805h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 8.805H26.55v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 8.805h-3.004v3.004h3.003zM38.3 8.805h-3.002v3.004H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 8.805h-3.004v3.004h3.004zM47.048 8.805h-3.003v3.004h3.003zM52.88 8.805h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 8.805h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 8.805h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 8.805h-3.003v3.004h3.003zM67.459 8.805h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 8.805h-3.003v3.004h3.003zM76.206 8.805h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 8.805h-3.004v3.004h3.004zM26.638 11.721h-3.004v3.003h3.004zM38.3 11.721h-3.002v3.003H38.3zM49.964 11.721H46.96v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 11.721h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 11.721h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 11.721h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 11.721h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 11.721h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 11.721h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 11.721h-3.003v3.003h3.003zM76.206 11.721h-3.003v3.003h3.003zM84.953 11.721H81.95v3.003h3.003zM26.638 14.637h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 14.637H26.55v3.003h3.003zM35.385 14.637h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 14.637h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 14.637h-3.004v3.003h3.004zM55.795 14.637h-3.003v3.003h3.003zM67.459 14.637h-3.004v3.003h3.004zM79.122 14.637h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 14.637h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 14.637H81.95v3.003h3.003zM26.638 17.553h-3.004v3.003h3.004zM32.47 17.553h-3.004v3.003h3.003zM38.3 17.553h-3.002v3.003H38.3zM44.132 17.553H41.13v3.003h3.003zM49.964 17.553H46.96v3.003h3.003zM55.795 17.553h-3.003v3.003h3.003zM61.627 17.553h-3.003v3.003h3.003zM67.459 17.553h-3.004v3.003h3.004zM73.29 17.553h-3.003v3.003h3.003zM79.122 17.553h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 17.553H81.95v3.003h3.003zM26.638 20.469h-3.004v3.003h3.004zM32.47 20.469h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 20.469h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 20.469h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 20.469h-3.004v3.003h3.004zM64.543 20.469h-3.004v3.003h3.004zM70.374 20.469h-3.003v3.003h3.003zM79.122 20.469h-3.004v3.003h3.004zM84.953 20.469H81.95v3.003h3.003zM3.311 23.384H.308v3.003h3.003zM9.143 23.384H6.14v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 23.384H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.806 23.384h-3.003v3.003h3.003zM29.553 23.384H26.55v3.003h3.003zM38.3 23.384h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 23.384h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 23.384H41.13v3.003h3.003zM52.88 23.384h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 23.384h-3.003v3.003h3.003zM67.459 23.384h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 23.384h-3.004v3.003h3.004zM90.785 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 23.384h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 23.384h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 23.384H96.53v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.448 23.384h-3.003v3.003h3.003zM9.143 26.3H6.14v3.003h3.003zM14.974 26.3h-3.003v3.003h3.003zM26.638 26.3h-3.004v3.003h3.004zM35.385 26.3h-3.003v3.003h3.003zM41.217 26.3h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 26.3H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 26.3h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 26.3H46.96v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 26.3h-3.004v3.003h3.004zM58.711 26.3h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 26.3h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 26.3h-3.004v3.003h3.004zM70.374 26.3h-3.003v3.003h3.003zM84.953 26.3H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 26.3h-3.004v3.003h3.003zM93.7 26.3h-3.003v3.003h3.004zM105.364 26.3h-3.003v3.003h3.003zM3.311 29.216H.308v3.003h3.003zM12.059 29.216H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 29.216h-3.003v3.003h3.003zM20.806 29.216h-3.003v3.003h3.003zM26.638 29.216h-3.004v3.003h3.004zM35.385 29.216h-3.003v3.003h3.003zM41.217 29.216h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 29.216H41.13v3.003h3.003zM52.88 29.216h-3.004v3.003h3.004zM64.543 29.216h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 29.216h-3.004v3.003h3.004zM76.206 29.216h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 29.216h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 29.216h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 29.216H81.95v3.003h3.003zM90.785 29.216h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 29.216h-3.003v3.003h3.004zM99.532 29.216H96.53v3.003h3.003zM105.364 29.216h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 29.216h-3.004v3.003h3.004zM3.311 32.132H.308v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.227 32.132H3.224v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 32.132H6.14v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 32.132H9.055v3.003h3.004zM29.553 32.132H26.55v3.003h3.003zM38.3 32.132h-3.002v3.003H38.3zM44.132 32.132H41.13v3.003h3.003zM49.964 32.132H46.96v3.003h3.003zM64.543 32.132h-3.004v3.003h3.004zM79.122 32.132h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 32.132h-3.004v3.003h3.003zM90.785 32.132h-3.003v3.003h3.003zM99.532 32.132H96.53v3.003h3.003zM108.28 32.132h-3.004v3.003h3.004zM6.227 35.047H3.224v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 35.047H6.14v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 35.047H9.055v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 35.047h-3.003v3.004h3.003zM20.806 35.047h-3.003v3.004h3.003zM26.638 35.047h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 35.047H26.55v3.004h3.003zM38.3 35.047h-3.002v3.004H38.3zM44.132 35.047H41.13v3.004h3.003zM49.964 35.047H46.96v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 35.047h-3.004v3.004h3.004zM61.627 35.047h-3.003v3.004h3.003zM67.459 35.047h-3.004v3.004h3.004zM73.29 35.047h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 35.047h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 35.047h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 35.047h-3.004v3.004h3.003zM87.87 35.047h-3.004v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 35.047h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 35.047h-3.003v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 35.047h-3.003v3.004h3.003zM102.448 35.047h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 35.047h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 35.047h-3.004v3.004h3.004zM17.89 37.963h-3.003v3.004h3.003zM26.638 37.963h-3.004v3.004h3.004zM35.385 37.963h-3.003v3.004h3.003zM41.217 37.963h-3.004v3.004h3.004zM49.964 37.963H46.96v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 37.963h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 37.963h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 37.963h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 37.963h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 37.963h-3.004v3.004h3.004zM70.374 37.963h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 37.963h-3.003v3.004h3.003zM84.953 37.963H81.95v3.004h3.003zM93.7 37.963h-3.003v3.004h3.004zM3.311 40.879H.308v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.227 40.879H3.224v3.003h3.003zM12.059 40.879H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 40.879h-3.003v3.003h3.003zM20.806 40.879h-3.003v3.003h3.003zM26.638 40.879h-3.004v3.003h3.004zM32.47 40.879h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 40.879h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 40.879h-3.002v3.003H38.3zM44.132 40.879H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 40.879h-3.003v3.003h3.003zM67.459 40.879h-3.004v3.003h3.004zM82.038 40.879h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 40.879H81.95v3.003h3.003zM90.785 40.879h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 40.879h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 40.879h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 40.879H96.53v3.003h3.003zM105.364 40.879h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 40.879h-3.004v3.003h3.004zM6.227 43.795H3.224v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 43.795H6.14v3.003h3.003zM14.974 43.795h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 43.795h-3.003v3.003h3.003zM26.638 43.795h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 43.795H26.55v3.003h3.003zM41.217 43.795h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 43.795H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 43.795h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 43.795H46.96v3.003h3.003zM64.543 43.795h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 43.795h-3.004v3.003h3.004zM79.122 43.795h-3.004v3.003h3.004zM84.953 43.795H81.95v3.003h3.003zM90.785 43.795h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 43.795h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 43.795h-3.003v3.003h3.003zM105.364 43.795h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 43.795h-3.004v3.003h3.004zM6.227 46.71H3.224v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 46.71H6.14v3.004h3.003zM14.974 46.71h-3.003v3.004h3.003zM20.806 46.71h-3.003v3.004h3.003zM32.47 46.71h-3.004v3.004h3.003zM38.3 46.71h-3.002v3.004H38.3zM44.132 46.71H41.13v3.004h3.003zM49.964 46.71H46.96v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 46.71h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 46.71h-3.003v3.004h3.003zM61.627 46.71h-3.003v3.004h3.003zM67.459 46.71h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 46.71h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 46.71h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 46.71h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 46.71h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 46.71h-3.004v3.004h3.003zM87.87 46.71h-3.004v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 46.71h-3.003v3.004h3.003zM96.616 46.71h-3.003v3.004h3.003zM102.448 46.71h-3.003v3.004h3.003zM3.311 49.626H.308v3.004h3.003zM9.143 49.626H6.14v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 49.626H9.055v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 49.626h-3.003v3.004h3.003zM23.722 49.626h-3.004v3.004h3.004zM29.553 49.626H26.55v3.004h3.003zM35.385 49.626h-3.003v3.004h3.003zM47.048 49.626h-3.003v3.004h3.003zM58.711 49.626h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 49.626h-3.003v3.004h3.003zM70.374 49.626h-3.003v3.004h3.003zM76.206 49.626h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 49.626h-3.004v3.004h3.004zM84.953 49.626H81.95v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 49.626h-3.004v3.004h3.003zM93.7 49.626h-3.003v3.004h3.004zM102.448 49.626h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 49.626h-3.003v3.004h3.003zM3.311 52.542H.308v3.003h3.003zM12.059 52.542H9.055v3.003h3.004zM20.806 52.542h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.722 52.542h-3.004v3.003h3.004zM29.553 52.542H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 52.542h-3.004v3.003h3.003zM44.132 52.542H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 52.542h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 52.542H46.96v3.003h3.003zM67.459 52.542h-3.004v3.003h3.004zM79.122 52.542h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 52.542h-3.004v3.003h3.003zM87.87 52.542h-3.004v3.003h3.003zM96.616 52.542h-3.003v3.003h3.003zM105.364 52.542h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 52.542h-3.004v3.003h3.004zM3.311 55.458H.308v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.227 55.458H3.224v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 55.458H6.14v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 55.458H9.055v3.003h3.004zM26.638 55.458h-3.004v3.003h3.004zM32.47 55.458h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 55.458h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 55.458h-3.002v3.003H38.3zM47.048 55.458h-3.003v3.003h3.003zM55.795 55.458h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 55.458h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 55.458h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 55.458h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 55.458h-3.004v3.003h3.004zM84.953 55.458H81.95v3.003h3.003zM90.785 55.458h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 55.458h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 55.458h-3.003v3.003h3.003zM108.28 55.458h-3.004v3.003h3.004zM9.143 58.374H6.14v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 58.374H9.055v3.003h3.004zM17.89 58.374h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.806 58.374h-3.003v3.003h3.003zM26.638 58.374h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 58.374H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 58.374h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 58.374h-3.003v3.003h3.003zM41.217 58.374h-3.004v3.003h3.004zM47.048 58.374h-3.003v3.003h3.003zM52.88 58.374h-3.004v3.003h3.004zM61.627 58.374h-3.003v3.003h3.003zM67.459 58.374h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 58.374h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 58.374h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 58.374h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 58.374h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 58.374h-3.004v3.003h3.003zM87.87 58.374h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 58.374h-3.003v3.003h3.003zM96.616 58.374h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 58.374H96.53v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.448 58.374h-3.003v3.003h3.003zM12.059 61.29H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 61.29h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 61.29h-3.003v3.003h3.003zM23.722 61.29h-3.004v3.003h3.004zM29.553 61.29H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 61.29h-3.004v3.003h3.003zM44.132 61.29H41.13v3.003h3.003zM49.964 61.29H46.96v3.003h3.003zM55.795 61.29h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 61.29h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 61.29h-3.003v3.003h3.003zM67.459 61.29h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 61.29h-3.003v3.003h3.003zM76.206 61.29h-3.003v3.003h3.003zM84.953 61.29H81.95v3.003h3.003zM99.532 61.29H96.53v3.003h3.003zM6.227 64.205H3.224v3.004h3.003zM12.059 64.205H9.055v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.806 64.205h-3.003v3.004h3.003zM26.638 64.205h-3.004v3.004h3.004zM32.47 64.205h-3.004v3.004h3.003zM38.3 64.205h-3.002v3.004H38.3zM47.048 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 64.205H46.96v3.004h3.003zM55.795 64.205h-3.003v3.004h3.003zM61.627 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 64.205h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 64.205h-3.004v3.004h3.004zM82.038 64.205h-3.004v3.004h3.003zM90.785 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 64.205h-3.003v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 64.205H96.53v3.004h3.003zM105.364 64.205h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 64.205h-3.004v3.004h3.004zM6.227 67.121H3.224v3.003h3.003zM12.059 67.121H9.055v3.003h3.004zM26.638 67.121h-3.004v3.003h3.004zM32.47 67.121h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 67.121h-3.003v3.003h3.003zM47.048 67.121h-3.003v3.003h3.003zM64.543 67.121h-3.004v3.003h3.004zM70.374 67.121h-3.003v3.003h3.003zM84.953 67.121H81.95v3.003h3.003zM90.785 67.121h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 67.121h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 67.121h-3.003v3.003h3.003zM105.364 67.121h-3.003v3.003h3.003zM6.227 70.037H3.224v3.003h3.003zM12.059 70.037H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 70.037h-3.003v3.003h3.003zM20.806 70.037h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.722 70.037h-3.004v3.003h3.004zM29.553 70.037H26.55v3.003h3.003zM55.795 70.037h-3.003v3.003h3.003zM70.374 70.037h-3.003v3.003h3.003zM76.206 70.037h-3.003v3.003h3.003zM84.953 70.037H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 70.037h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 70.037h-3.003v3.003h3.003zM96.616 70.037h-3.003v3.003h3.003zM102.448 70.037h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 70.037h-3.003v3.003h3.003zM3.311 72.953H.308v3.003h3.003zM12.059 72.953H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 72.953h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 72.953h-3.003v3.003h3.003zM23.722 72.953h-3.004v3.003h3.004zM29.553 72.953H26.55v3.003h3.003zM35.385 72.953h-3.003v3.003h3.003zM44.132 72.953H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 72.953h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 72.953H46.96v3.003h3.003zM55.795 72.953h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 72.953h-3.003v3.003h3.003zM64.543 72.953h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 72.953h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 72.953h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 72.953h-3.003v3.003h3.003zM84.953 72.953H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 72.953h-3.004v3.003h3.003zM99.532 72.953H96.53v3.003h3.003zM3.311 75.868H.308v3.004h3.003zM9.143 75.868H6.14v3.004h3.003zM14.974 75.868h-3.003v3.004h3.003zM20.806 75.868h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.722 75.868h-3.004v3.004h3.004zM35.385 75.868h-3.003v3.004h3.003zM41.217 75.868h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 75.868H41.13v3.004h3.003zM61.627 75.868h-3.003v3.004h3.003zM73.29 75.868h-3.003v3.004h3.003zM79.122 75.868h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 75.868h-3.004v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 75.868H81.95v3.004h3.003zM90.785 75.868h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 75.868h-3.003v3.004h3.004zM102.448 75.868h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 75.868h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 75.868h-3.004v3.004h3.004zM3.311 78.784H.308v3.003h3.003zM9.143 78.784H6.14v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059 78.784H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 78.784h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 78.784h-3.003v3.003h3.003zM26.638 78.784h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 78.784H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 78.784h-3.004v3.003h3.003zM38.3 78.784h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 78.784h-3.004v3.003h3.004zM49.964 78.784H46.96v3.003h3.003zM58.711 78.784h-3.003v3.003h3.003zM64.543 78.784h-3.004v3.003h3.004zM79.122 78.784h-3.004v3.003h3.004zM84.953 78.784H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 78.784h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 78.784h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 78.784h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 78.784h-3.003v3.003h3.003zM105.364 78.784h-3.003v3.003h3.003zM3.311 81.7H.308v3.003h3.003zM12.059 81.7H9.055v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.974 81.7h-3.003v3.003h3.003zM20.806 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.722 81.7h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.638 81.7h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 81.7H26.55v3.003h3.003zM38.3 81.7h-3.002v3.003H38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.217 81.7h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 81.7H41.13v3.003h3.003zM52.88 81.7h-3.004v3.003h3.004zM67.459 81.7h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 81.7h-3.003v3.003h3.003zM84.953 81.7H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 81.7h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 81.7h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 81.7H96.53v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.448 81.7h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 81.7h-3.003v3.003h3.003zM26.638 84.616h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 84.616H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 84.616h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 84.616h-3.003v3.003h3.003zM41.217 84.616h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 84.616H41.13v3.003h3.003zM49.964 84.616H46.96v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 84.616h-3.004v3.003h3.004zM58.711 84.616h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 84.616h-3.003v3.003h3.003zM70.374 84.616h-3.003v3.003h3.003zM82.038 84.616h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 84.616H81.95v3.003h3.003zM96.616 84.616h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 84.616H96.53v3.003h3.003zM105.364 84.616h-3.003v3.003h3.003zM32.47 87.532h-3.004v3.003h3.003zM44.132 87.532H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 87.532h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 87.532H46.96v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 87.532h-3.004v3.003h3.004zM61.627 87.532h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 87.532h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 87.532h-3.004v3.003h3.004zM76.206 87.532h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 87.532h-3.004v3.003h3.004zM84.953 87.532H81.95v3.003h3.003zM90.785 87.532h-3.003v3.003h3.003zM96.616 87.532h-3.003v3.003h3.003zM102.448 87.532h-3.003v3.003h3.003zM108.28 87.532h-3.004v3.003h3.004zM26.638 90.447h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 90.447H26.55v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 90.447h-3.004v3.004h3.003zM44.132 90.447H41.13v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 90.447h-3.003v3.004h3.003zM52.88 90.447h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.795 90.447h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.711 90.447h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 90.447h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 90.447h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 90.447h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 90.447h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 90.447h-3.003v3.004h3.003zM82.038 90.447h-3.004v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 90.447H81.95v3.004h3.003zM96.616 90.447h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 90.447H96.53v3.004h3.003zM105.364 90.447h-3.003v3.004h3.003zM26.638 93.363h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 93.363H26.55v3.003h3.003zM41.217 93.363h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.132 93.363H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 93.363H46.96v3.003h3.003zM58.711 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.627 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 93.363h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 93.363h-3.004v3.003h3.004zM73.29 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 93.363h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 93.363h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 93.363H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 93.363h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 93.363h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 93.363h-3.003v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.616 93.363h-3.003v3.003h3.003zM102.448 93.363h-3.003v3.003h3.003zM108.28 93.363h-3.004v3.003h3.004zM26.638 96.279h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 96.279H26.55v3.003h3.003zM47.048 96.279h-3.003v3.003h3.003zM55.795 96.279h-3.003v3.003h3.003zM61.627 96.279h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 96.279h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 96.279h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 96.279h-3.003v3.003h3.003zM76.206 96.279h-3.003v3.003h3.003zM87.87 96.279h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.785 96.279h-3.003v3.003h3.003zM96.616 96.279h-3.003v3.003h3.003zM102.448 96.279h-3.003v3.003h3.003zM108.28 96.279h-3.004v3.003h3.004zM26.638 99.195h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.553 99.195H26.55v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 99.195h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 99.195h-3.003v3.003h3.003zM44.132 99.195H41.13v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.964 99.195H46.96v3.003h3.003zM61.627 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 99.195h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 99.195h-3.004v3.003h3.004zM73.29 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 99.195h-3.004v3.003h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.038 99.195h-3.004v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 99.195H81.95v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87 99.195h-3.004v3.003h3.003zM102.448 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 99.195h-3.003v3.003h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 99.195h-3.004v3.003h3.004zM29.553 102.11H26.55v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47 102.11h-3.004v3.004h3.003zM38.3 102.11h-3.002v3.004H38.3zM44.132 102.11H41.13v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 102.11h-3.003v3.004h3.003zM55.795 102.11h-3.003v3.004h3.003zM61.627 102.11h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.543 102.11h-3.004v3.004h3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.459 102.11h-3.004v3.004h3.004zM73.29 102.11h-3.003v3.004h3.003zM82.038 102.11h-3.004v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.953 102.11H81.95v3.004h3.003zM90.785 102.11h-3.003v3.004h3.003zM96.616 102.11h-3.003v3.004h3.003zM108.28 102.11h-3.004v3.004h3.004zM26.638 105.026h-3.004v3.004h3.004zM35.385 105.026h-3.003v3.004h3.003zM44.132 105.026H41.13v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.048 105.026h-3.003v3.004h3.003zM52.88 105.026h-3.004v3.004h3.004zM70.374 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.122 105.026h-3.004v3.004h3.004zM96.616 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.532 105.026H96.53v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.448 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.364 105.026h-3.003v3.004h3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28 105.026h-3.004v3.004h3.004zM.308.058v20.41h20.41V.058zm17.495 17.495H3.223V2.973h14.58zM87.782.058v20.41h20.41V.058zm17.494 17.495H90.697V2.973h14.579zM.308 87.532v20.41h20.41v-20.41zm17.495 17.494H3.223V90.447h14.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.887 5.89H6.14v8.747h8.747zM102.361 5.89h-8.748v8.747h8.748zM14.887 93.363H6.14v8.747h8.747z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "510a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25 0h108v108H.25z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "511b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25 0h108v108H.25z"
  })))));
});
const SvgGooglePlayQr = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayQr);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "24903d422bca2750062cfffe7f7d428b.svg";